module.exports = __webpack_public_path__ + "img/cuccLog.9afd3620.jpg";